// extracted by mini-css-extract-plugin
var _1 = "fD5Bs1WQmScO5iki8mKz";
var _2 = "buk1FzU0U6W3tp9ABSEc";
export { _1 as "transparent", _2 as "wrapper" }
